/* src/app/front-layout/calendar/sat-test/sat-test.component.css */
.hero-section {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background:
    linear-gradient(
      135deg,
      #f7f7f7 0%,
      #ffffff 50%,
      #ffffff 100%);
  overflow: hidden;
}
.hero-section::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -10%;
  width: 800px;
  height: 800px;
  background:
    radial-gradient(
      circle,
      rgba(255, 183, 77, 0.15) 0%,
      transparent 70%);
  border-radius: 50%;
  animation: pulse 4s ease-in-out infinite;
}
.hero-section::after {
  content: "";
  position: absolute;
  bottom: -30%;
  left: -5%;
  width: 600px;
  height: 600px;
  background:
    radial-gradient(
      circle,
      rgba(33, 150, 243, 0.15) 0%,
      transparent 70%);
  border-radius: 50%;
  animation: pulse 4s ease-in-out infinite 2s;
}
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.5;
  }
}
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  position: relative;
  z-index: 1;
}
.hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}
.hero-left {
  animation: slideInLeft 0.8s ease-out;
}
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.badge {
  display: inline-block;
  background:
    linear-gradient(
      135deg,
      #FFB74D,
      #FFA726);
  color: #1a1a2e;
  padding: 12px 24px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 30px;
  box-shadow: 0 4px 15px rgba(255, 183, 77, 0.3);
}
h1 {
  font-size: 64px;
  font-weight: 800;
  color: #075681;
  line-height: 1.2;
  margin-bottom: 20px;
}
.highlight {
  background: #101010;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.subtitle {
  font-size: 24px;
  color: #090909;
  margin-bottom: 15px;
  font-weight: 600;
}
.description {
  font-size: 18px;
  color: #0b0b0b;
  margin-bottom: 40px;
  line-height: 1.6;
}
.features-inline {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}
.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #030303;
  font-size: 16px;
}
.feature-icon {
  width: 24px;
  height: 24px;
  background:
    linear-gradient(
      135deg,
      #2196F3,
      #1976D2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
}
.cta-button {
  display: inline-block;
  background: #075681;
  color: #ffffff;
  padding: 18px 50px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: #73ccfc;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}
.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: #73ccfc;
}
.hero-right {
  position: relative;
  animation: slideInRight 0.8s ease-out;
}
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.image-card {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  transform: perspective(1000px) rotateY(-5deg);
  transition: all 0.5s ease;
}
.image-card:hover {
  transform: perspective(1000px) rotateY(0deg) scale(1.02);
}
.image-card img {
  width: 100%;
  height: auto;
  display: block;
}
.stat-badges {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.stat-badge {
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  padding: 15px 25px;
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.8s ease-out forwards;
  opacity: 0;
}
.stat-badge:nth-child(1) {
  animation-delay: 0.3s;
}
.stat-badge:nth-child(2) {
  animation-delay: 0.5s;
}
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
.stat-value {
  font-size: 24px;
  font-weight: 800;
  background:
    linear-gradient(
      135deg,
      #2196F3,
      #1976D2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.stat-label {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
  font-weight: 600;
}
.floating-element {
  position: absolute;
  background:
    linear-gradient(
      135deg,
      rgba(33, 150, 243, 0.15),
      rgba(25, 118, 210, 0.15));
  border-radius: 20px;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.floating-1 {
  width: 100px;
  height: 100px;
  top: 10%;
  left: -50px;
  animation: float 6s ease-in-out infinite;
}
.floating-2 {
  width: 150px;
  height: 150px;
  bottom: 10%;
  right: -75px;
  animation: float 8s ease-in-out infinite 2s;
}
@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(5deg);
  }
}
@media (max-width: 1024px) {
  .hero-content {
    grid-template-columns: 1fr;
    gap: 60px;
    text-align: center;
  }
  h1 {
    font-size: 48px;
  }
  .features-inline {
    justify-content: center;
  }
  .image-card {
    transform: none;
  }
  .hero-left {
    order: 1;
  }
  .hero-right {
    order: 2;
  }
}
@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }
  h1 {
    font-size: 36px;
  }
  .subtitle {
    font-size: 20px;
  }
  .description {
    font-size: 16px;
  }
  .features-inline {
    flex-direction: column;
    align-items: center;
  }
  .stat-badges {
    position: static;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
  }
}
.cal-inst {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 50px;
}
.cal-inst h1 {
  font-weight: bold;
}
.cal-inst h2 {
  font-size: 24px;
}
.reset-btn {
  width: 250px;
  background-color: #007BA7;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 18px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.reset-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(253, 241, 13, 0.4);
}
.mtc-title {
  font-weight: 800;
  text-align: center;
  margin: 8px 0 24px;
  color: #0f172a;
  font-size: 32px;
}
.mock-calendar {
  --toolbar: #FFBF00;
  --toolbar-dark: #007BA7;
  --online: #fb923c;
  --ff: #007BA7;
  --book: #FFBF00;
  --book-dark: #007BA7;
  --card-border: #dbeafe;
  --card-hover: #1d4ed8;
}
.mock-calendar .toolbar {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--toolbar);
  padding: 20px;
  border-radius: 12px;
  margin: 0 8px 24px;
}
.search-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  width: 50%;
}
.mock-calendar .search-input {
  border: none;
  background: #fff;
  border-radius: 999px;
  padding: 10px 14px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .08) inset;
  font-weight: 600;
  width: 100%;
}
.flt-text {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px;
}
.mock-calendar .toolbar .toolbar-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}
.mock-calendar .toolbar .toolbar-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
}
.mock-calendar .toolbar .toolbar-item label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .03em;
  color: #333;
  margin: 0;
  text-align: center;
}
.mock-calendar .toolbar .dropdown-like {
  width: 250px;
  position: relative;
}
.mock-calendar .toolbar .dropdown-like .form-select,
.mock-calendar .toolbar .dropdown-like select {
  appearance: none;
  border: none;
  background: #fff;
  border-radius: 20px;
  padding: 8px 28px 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  font-weight: 600;
  font-size: 13px;
  width: 100%;
  cursor: pointer;
}
.mock-calendar .toolbar .dropdown-like .chev {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  pointer-events: none;
  color: #666;
}
.list-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mock-calendar .session-card {
  width: 80%;
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  margin-top: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: auto 1fr auto auto auto;
  align-items: center;
  gap: 16px;
  transition: all 0.2s ease;
}
.mock-calendar .list-body .session-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
.mock-calendar .list-body .session-card .date-chip {
  background: #0a84ae;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 800;
  font-size: 14px;
  white-space: nowrap;
  min-width: 100px;
  text-align: center;
}
.mock-calendar .list-body .session-card .date-chip.range {
  background: #f59e0b;
}
.mock-calendar .list-body .session-card .date-chip span {
  color: inherit;
  background: none;
  padding: 0;
  border-radius: 0;
  font-weight: inherit;
}
.mock-calendar .list-body .session-card .session-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mock-calendar .list-body .session-card .session-title {
  font-weight: 700;
  color: #1e40af;
  text-decoration: none;
  font-size: 16px;
}
.mock-calendar .list-body .session-card .session-subtitle {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  text-decoration: none;
}
.mock-calendar .list-body .session-card .session-pattern {
  font-size: 18px;
  font-weight: 600;
  color: #6b7280;
}
.mock-calendar .list-body .session-card .badges {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.mock-calendar .list-body .session-card .badges .badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 16px;
  color: #fff;
}
.mock-calendar .list-body .session-card .badges .badge-online {
  background: var(--online);
}
.mock-calendar .list-body .session-card .badges .badge-ff {
  background: var(--ff);
}
.mock-calendar .list-body .session-card .badges .location-badge {
  background: #007BA7;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.mock-calendar .list-body .session-card .badges .location-badge img {
  width: 14px;
  height: 14px;
}
.mock-calendar .list-body .session-card .badges .location-badge .truncate {
  max-width: 120px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mock-calendar .list-body .session-card .price {
  font-weight: 800;
  font-size: 16px;
  color: #0f172a;
  min-width: 80px;
  align-self: center;
}
.mock-calendar .list-body .session-card .action .btn-book,
.mock-calendar .btn-book {
  width: 200px;
  background: var(--book);
  color: #020202;
  border-radius: 20px;
  padding: 10px 24px;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  transition: background 0.2s ease;
  min-width: 80px;
  border: none;
  cursor: pointer;
}
.mock-calendar .btn-book:hover {
  background: var(--book-dark);
}
.mock-calendar .btn-load {
  background: var(--toolbar-dark);
  color: #111827;
  border-radius: 20px;
  padding: 12px 24px;
  font-weight: 800;
  border: none;
  cursor: pointer;
  font-size: 14px;
}
.mock-calendar .btn-load:hover {
  background: #d69e00;
}
.location-badge {
  background: #007BA7;
}
.hidden {
  display: none;
}
@media (max-width: 991.98px) {
  .mock-calendar .toolbar .toolbar-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .mock-calendar .toolbar .toolbar-item {
    min-width: 200px;
  }
  .mock-calendar .list-body .session-card {
    grid-template-columns: 1fr;
    gap: 12px;
    text-align: center;
  }
  .mock-calendar .list-body .session-card .session-info {
    align-items: center;
  }
  .mock-calendar .list-body .session-card .badges {
    justify-content: center;
  }
}
@media (max-width: 575.98px) {
  .mock-calendar .toolbar .toolbar-row {
    grid-template-columns: 1fr;
  }
}
.section-8 {
  margin-top: 50px;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
}
.section-8 h1 {
  font-size: 60px;
  font-weight: 500;
}
.sec-4 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sec-4 h2 {
  font-size: 36px;
  font-weight: 500;
  margin: 0px;
}
.sec-4 h1 {
  color: #ED6823;
  font-size: 42px;
  margin: 10px 0 0 0;
}
.cs-sec {
  display: flex;
  gap: 50px;
  margin-top: 50px;
}
.cs-crd {
  display: flex;
  padding: 20px;
  width: 420px;
  gap: 5px;
  border-radius: 15px;
  background-color: #F7F7F7;
}
.cs-sec iframe {
  width: 460px;
  height: 275px;
}
.crd-cir {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: #D9D9D9;
  border-radius: 50%;
  padding: 10px;
}
.info {
  display: flex;
  flex-direction: column;
}
.strp-2 {
  margin-top: 5%;
  padding: 50px;
  background-color: #ED6823;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.strp-2 h1 {
  color: #ffffff;
  text-align: center;
  font-weight: 400;
}
.cta-4 {
  padding: 20px;
  background-color: #fff;
  width: 300px;
  text-decoration: none;
  text-align: center;
  border-radius: 15px;
  color: #0066FF;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}
@media (max-width: 700px) {
  .purchase-popup {
    left: 5vw;
    bottom: 14vw;
    padding: 9px 10px;
    min-width: 130px;
    font-size: 0.92rem;
  }
  .popup-course {
    font-size: 0.97rem;
  }
}
@media (max-width: 768px) {
  .mock-test-wrapper {
    padding: 20px;
    height: auto;
    min-height: 70vh;
    background-attachment: scroll;
  }
  .title {
    font-size: 40px;
    text-align: center;
    margin-bottom: 15px;
  }
  .subtitle {
    font-size: 24px;
    text-align: center;
    margin-bottom: 15px;
  }
  .modes {
    font-size: 16px;
    text-align: center;
    margin-bottom: 30px;
  }
  .calendar-btn {
    width: 80%;
    margin-left: 0;
    font-size: 18px;
    padding: 15px 20px;
    border-radius: 15px;
    margin-top: 10px;
  }
  .mock-test-wrapper {
    background-position: center center;
  }
  .marquee {
    display: none;
  }
  .logo3 {
    width: 100px;
    height: 50px;
  }
  .top p {
    font-size: 12px;
  }
  .nw-strp {
    gap: 10px;
    padding: 5px;
  }
  .nw-strp h5 {
    font-size: 11px;
  }
  .nw-strp-lft {
    gap: 5px;
  }
  .nw-strp-rgt {
    gap: 5px;
  }
  .bk-dm {
    padding: 5px;
    font-size: 10px;
  }
  .to-nmt {
    font-size: 10px;
    padding: 5px;
  }
  .trust-pilot img {
    width: 100px;
    height: 50px;
  }
  .hs-h1 {
    font-size: 30px;
  }
  .hs-h2 {
    font-size: 24px;
    text-align: center;
  }
  .hero-section h2 {
    text-align: center;
    font-size: 18px;
    margin-left: 10px;
    margin-right: 10px;
    line-height: 20px;
  }
  .hero-section h3 {
    font-size: 18px;
    text-align: center;
  }
  .hero-section h4 {
    font-size: 16px;
  }
  .hs-btns {
    flex-direction: column;
  }
  .hero-section ul {
    flex-direction: column;
  }
  .stripe h3 {
    font-size: 20px;
    text-align: center;
  }
  .af-ts h1 {
    font-size: 24px;
  }
  .ft-sc h1 {
    text-align: center;
    font-size: 24px !important;
  }
  .left {
    margin-left: 00px;
  }
  .right {
    margin-right: 00px;
  }
  .container {
    padding: 10px;
    height: auto;
  }
  .header2 h1 {
    font-size: 18px;
    padding-left: 10px;
  }
  .header2 h2 {
    font-size: 14px;
    display: none;
  }
  .logo-mocktest {
    width: 80px;
    height: 30px;
  }
  .tabs {
    gap: 5px;
    flex-wrap: wrap;
  }
  .tab {
    padding: 8px 12px;
    font-size: 14px;
  }
  .timetable {
    margin-top: 10px;
  }
  .test-row {
    height: auto;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
  }
  .test-info.enhanced {
    height: auto;
    flex: none;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 10px;
    text-align: center;
  }
  .test-date {
    width: auto;
    font-size: 16px;
    margin-top: 10px;
  }
  .testName {
    font-size: 16px;
  }
  .btn-tab {
    font-size: 14px;
    text-align: center;
  }
  .cal-inst h1 {
    font-weight: bold;
    font-size: 28px;
    text-align: center;
  }
  .cal-inst h2 {
    font-size: 18px;
    text-align: center;
  }
  .test-centers {
    flex-direction: column;
    gap: 10px;
    margin: 10px 0;
  }
  .center {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
  }
  .book-btn {
    display: block;
    margin-top: 10px;
  }
  .ft-sc-info {
    flex-direction: column;
    align-items: center;
  }
  .ft-sc {
    height: 100%;
  }
  .ft-sc h1 {
    text-align: center;
    font-size: 24px !important;
  }
  .ft-sc-item {
    width: 250px;
    height: 200px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .ft-sc-item img {
    margin: 5px;
    width: 45px;
  }
  .ft-sc-item h3 {
    font-size: 18px;
    line-height: 20px;
  }
  .ft-sc p {
    font-size: 14px;
  }
  .co-sc h1 {
    margin-top: 25px;
    font-size: 22px;
  }
  .ts-sc {
    flex-direction: column;
  }
  .card-ts {
    width: 300px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-ts h4 {
    font-size: 16px;
  }
  .card-ts p {
    font-size: 12px;
  }
  .faq-sc h1 {
    margin-top: 25px;
    font-size: 36px;
  }
  .drop-d {
    width: 90%;
  }
  .faq-sc h3 {
    font-size: 18px;
    line-height: 25px;
  }
  .calendar-wrapper {
    width: 100%;
    margin-top: 100px;
    border-radius: 0;
    box-shadow: none;
  }
  .calendar-header {
    flex-direction: column;
    gap: 0;
  }
  .calendar-mode-buttons,
  .calendar-type-buttons {
    height: auto;
    padding: 15px 10px;
    border-radius: 0 !important;
    flex-wrap: wrap;
  }
  .calendar-month-selector {
    margin: 10px 0;
    padding: 0 10px;
    justify-content: flex-start;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .calendar-test-group {
    margin-left: 10px;
    margin-right: 10px;
  }
  .calendar-test-details-main {
    gap: 10px;
  }
  .calendar-test-details {
    flex-direction: column;
    align-items: flex-start;
  }
  .calendar-test-details h4 {
    font-size: 18px;
  }
  .calendar-test-list {
    margin: 10px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .calendar-test-card {
    width: 100%;
    padding: 12px;
  }
  .calendar-test-card h5 {
    font-size: 16px;
  }
  .section-8 h1 {
    font-size: 30px;
    text-align: center;
  }
  .cs-sec {
    flex-direction: column;
    gap: 30px;
    padding: 0 15px;
  }
  .cs-sec iframe {
    width: 100%;
    height: 200px;
  }
  .cs-crd {
    width: 100%;
    margin: 0 auto;
  }
  .cta-1,
  .cta-2,
  .cta-3 {
    width: 90%;
    margin: 15px auto;
    display: block;
  }
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
}
/*# sourceMappingURL=sat-test.component.css.map */
